import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import "./ContactUs.css";
import phone from "../../assets/contactPath.svg";
import location from "../../assets/locationPath.svg";
import email from "../../assets/gmail 1.svg";
import OfficeAddress from "../../assets/Office-Address.svg";
import OfficeSiteAddress from "../../assets/SiteLocationPath.svg";

const ContactUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const handleAddressClick = () => {
    window.open(
      "https://www.google.com/maps/place/16%C2%B033'24.9%22N+80%C2%B023'07.0%22E/@16.5569229,80.3827019,17z/data=!3m1!4b1!4m4!3m3!8m2!3d16.5569229!4d80.3852768?entry=ttu&g_ep=EgoyMDI0MTAwMi4xIKXMDSoASAFQAw%3D%3D",
      "_blank"
    );
  };

  const handleOfficeAddressClick = () => {
    window.open(
      "https://www.google.com/maps/search/Thirumala+Enclave,+11-660+Phase+2,+1st+floor,+Above+Kotak+Mahindra+Bank,+Inner+Ring+Road,+Guntur+-+522+034./@16.8862254,78.8283266,9z/data=!3m1!4b1?entry=ttu&g_ep=EgoyMDI0MTAwMi4xIKXMDSoASAFQAw%3D%3D",
      "_blank"
    );
  };

  const handlePhoneClick = (phoneNumber) => {
    window.open(`tel:${phoneNumber}`);
  };

  const handleEmailClick = () => {
    window.open("mailto:dommarlapati77@gmail.com");
  };

  return (
    <div className="container-fluid py-5 contactContainer">
      <div className="container">
        <div>
          <p className="contactTitle">Contact us</p>
        </div>
        <div className="row justify-content-center mb-3">
          <div
            className="col-lg-6 d-flex justify-content-center mb-3"
            data-aos="fade-down"
            onClick={handleOfficeAddressClick}
            style={{ cursor: "pointer" }}
          >
            <div className="card contactCard align-items-center">
              <div className="d-flex justify-content-between align-items-center card-content">
                <img src={location} alt="address" className="card-icon-left" />
                <div className="contact-details mt-2">
                  <p className="contactLable">Office Address</p>
                  <p className="Contactcard-desc">
                    Thirumala Enclave, 11-660 Phase 2, 1st floor, Above Kotak
                    Mahindra Bank, Inner Ring Road, Guntur - 522 034.
                  </p>
                </div>
                <img
                  src={OfficeAddress}
                  alt="office-address"
                  className="card-icon-left"
                />
              </div>
            </div>
          </div>

          <div
            className="col-lg-6 d-flex justify-content-center mb-3"
            data-aos="fade-up"
            onClick={handleAddressClick}
            style={{ cursor: "pointer" }}
          >
            <div className="card contactCard align-items-center">
              <div className="d-flex justify-content-between align-items-center card-content">
                <img
                  src={location}
                  alt="site-address"
                  className="card-icon-left"
                />
                <div className="contact-details mt-2">
                  <p className="contactLable">Site Address</p>
                  <p className="Contactcard-desc">
                    Pedamaddur near vaikuntapuram
                  </p>
                </div>
                <img
                  src={OfficeSiteAddress}
                  alt="site-address"
                  className="card-icon-left"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-center mb-3">
          <div
            className="col-lg-6 d-flex justify-content-center mb-3"
            data-aos="fade-down"
            onClick={() => handlePhoneClick("9848772866")}
            style={{ cursor: "pointer" }}
          >
            <div className="card contactCard align-items-center p-4">
              <div className="d-flex justify-content-between align-items-center card-content">
                <div style={{ width: "0px" }}>
                  <img
                    src={phone}
                    alt="phone"
                    className="card-icon-left emailIcon"
                  />
                </div>
                <div className="contact-details">
                  <p className="contactLable emailName">Contact us</p>
                  <div className="d-flex flex-column">
                    <p className="Contactcard-desc">
                      Soma venkateshwarlu - 9848772866
                    </p>
                    <p
                      className="Contactcard-desc"
                      onClick={() => handlePhoneClick("9848861016")}
                    >
                      Soma Naresh - 98488 61016
                    </p>
                    <p className="Contactcard-desc">
                      Gabbeta Uday Kumar - 90324 81481
                    </p>
                  </div>
                </div>
                <div></div>
              </div>
            </div>
          </div>

          <div
            className="col-lg-6 d-flex justify-content-center mb-3"
            data-aos="fade-up"
            onClick={handleEmailClick}
            style={{ cursor: "pointer" }}
          >
            <div className="card contactCard align-items-center p-4">
              <div className="d-flex justify-content-between align-items-center card-content">
                <div style={{ width: "0px" }}>
                  <img
                    src={email}
                    alt="email"
                    className="card-icon-left emailIcon"
                  />
                </div>
                <div
                  className="contact-details"
                  style={{ marginLeft: "-50px" }}
                >
                  <p className="contactLable emailName">Email us</p>
                  <p className="Contactcard-desc emailDec">
                    dommarlapati77@gmail.com
                  </p>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
